module.exports = __webpack_public_path__ + "img/framework.b970d1e5.png";